import { dv } from '@aviv-estimation-funnel/data-validation/dv';
import { Box } from '@gemini/core';
import { formatNumberInputValue, formatTextInputValue } from '@mfe-helpers/format';
import FieldWrapper from '@mfe-presentation/components/Wrappers/FieldWrapper';
import { EUIComponent } from '@mfe-types/enum';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const EstimateFeedbackForm = () => {
    const { t } = useTranslation(NAME_SPACE);

    const radioFieldOptions = {
        values: [
            {
                value: 'FarTooHigh',
                label: t('common.fields.estimateFeedbackValue.farTooHigh'),
            },
            {
                value: 'TooHigh',
                label: t('common.fields.estimateFeedbackValue.tooHigh'),
            },
            {
                value: 'JustRight',
                label: t('common.fields.estimateFeedbackValue.justRight'),
            },
            {
                value: 'TooLow',
                label: t('common.fields.estimateFeedbackValue.tooLow'),
            },
            {
                value: 'FarTooLow',
                label: t('common.fields.estimateFeedbackValue.farTooLow'),
            },
        ],
    };

    return (
        <Box as="form" display="flex" flexDirection="column">
            <FieldWrapper
                name="estimateFeedbackValue"
                field={{
                    uiComponent: EUIComponent.Radio,
                    formatInputValue: formatTextInputValue,
                    isRequired: true,
                    direction: 'vertical',
                    options: radioFieldOptions,
                    validators: dv.string(),
                }}
            />
            <FieldWrapper
                name="estimateFeedbackExpectedPrice"
                field={{
                    uiComponent: EUIComponent.TextField,
                    formatInputValue: formatNumberInputValue,
                    isRequired: false,
                    defaultValue: '',
                    type: 'text',
                    inputMode: 'numeric',
                }}
            />
            <FieldWrapper
                name="estimateFeedbackReason"
                field={{
                    uiComponent: EUIComponent.TextArea,
                    formatInputValue: formatTextInputValue,
                    isRequired: false,
                    defaultValue: '',
                }}
            />
        </Box>
    );
};

export default EstimateFeedbackForm;
